import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWork() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const failures = [{
    action: 'Prohibir amistades directamente',
    result: "solo convirtió al 'amigo tóxico' en un mártir y a ti en el villano."
  }, {
    action: 'Quitarle el celular',
    result: 'causó un aislamiento social real que aumentó su ansiedad y resentimiento hacia ti.'
  }, {
    action: 'Los sermones sobre valores',
    result: "terminaron en 'tú no entiendes cómo es aquí', creando una brecha cultural insalvable."
  }, {
    action: "Esperar a que 'se le pase la etapa'",
    result: 'permitió que influencias externas echaran raíces profundas en su identidad.'
  }];
  return <section ref={ref} className="w-full bg-darker-navy py-16 md:py-20 px-6" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-oswald text-gold mb-10 text-center" data-id="element-148">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>

          <div className="space-y-6" data-id="element-149">
            {failures.map((failure, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex gap-4 items-start bg-dark-navy p-6 rounded-lg border border-red-900/30" data-id="element-150">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-151" />
                <p className="text-gray-300 leading-relaxed" data-id="element-152">
                  <span className="font-bold text-white" data-id="element-153">{failure.action}</span>{' '}
                  {failure.result}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}